import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-top: 24px;
`

export const Header = styled.div`
  display: flex;
  button {
    margin-left: 24px;
    padding: 0 12px;
    height: 40px;
    border: none;
    border-radius: 8px;
    background-color: #e7f3fe;
    font-size: 14px;
    font-weight: 700;
    color: #0085ff;
    box-shadow: none;
    svg {
      margin-left: 2px;
      margin-right: 6px;
    }
    &:hover {
      background-color: #dceefe;
      color: #0085ff;
    }
  }
`

export const Alert = styled.div`
  width: 100%;
  border: 1px solid #b6dbfb;
  background-color: #e7f3fe;
  padding: 8px;
  border-radius: 8px;
  font-size: 14px;
  color: #363636;
  display: flex;
  align-items: center;
  svg {
    margin-top: 2px;
    margin-left: 4px;
    margin-right: 12px;
    color: #213f68;
  }
`
